import type { IAction } from './interfaces'

export const sortActions = <T, P>(actions: IAction<T, P>[]) =>
  [...actions].sort((one, other) => one.priority - other.priority)
